import { Button, SupportForm, HelpLink } from "components";
import TextField from "material-ui/TextField";
import Checkbox from "material-ui/Checkbox";
import Formsy from "formsy-react";
import { FormsyText, FormsyCheckbox } from "formsy-material-ui";

import "./editSettings.scss";

export default class EditSettings extends React.Component {
  static propTypes = {
    data: React.PropTypes.object,
    saving: React.PropTypes.bool,
    onSave: React.PropTypes.func,
  };

  render() {
    const { data, saving, onSave } = this.props;

    return (
      <div className="edit-settings__section settings">
        <h2 className="edit-settings__section__heading">Settings</h2>
        <Formsy.Form onValidSubmit={onSave}>
          <div className="seosettings__row">
            <h2 className="small-spacing--bottom">Page Title</h2>
            <ul className="icon-font-list">
              <HelpLink
                title="How do I set up my page title settings?"
                url="https://support.pluginuseful.com/hc/en-us/articles/23534846096404-How-do-I-set-up-my-page-title-and-meta-description-settings"
              />
            </ul>
            <FormsyText
              floatingLabelText="Truncate over (characters)"
              defaultValue={data.pageTitleTruncateChars}
              disabled={saving}
              name="pageTitleTruncateChars"
              validations="isNumeric"
              validationError="Please enter only numbers"
              fullWidth={true}
            />
            <FormsyCheckbox
              label={
                <p className="body2">
                  Override manually entered page titles with templates
                </p>
              }
              defaultChecked={data.pageTitleTemplateApplyToAll}
              disabled={saving}
              name="pageTitleTemplateApplyToAll"
              className="small-spacing2--top"
            />
            <br />
            {/* ---------------------pageTitle ---------------------------------------------------------- */}
            <h3>Apply To:</h3>
            <FormsyCheckbox
              label={<p className="body2">Collections</p>}
              defaultChecked={data.pageTitleTruncateEnableForCollections}
              disabled={saving}
              name="pageTitleTruncateEnableForCollections"
              className="small-spacing2--top"
            />

            <FormsyCheckbox
              label={<p className="body2">Products</p>}
              defaultChecked={data.pageTitleTruncateEnableForProducts}
              disabled={saving}
              name="pageTitleTruncateEnableForProducts"
              className="small-spacing2--top"
            />

            <FormsyCheckbox
              label={<p className="body2">Pages</p>}
              defaultChecked={data.pageTitleTruncateEnableForPages}
              disabled={saving}
              name="pageTitleTruncateEnableForPages"
              className="small-spacing2--top"
            />

            <FormsyCheckbox
              label={<p className="body2">Articles</p>}
              defaultChecked={data.pageTitleTruncateEnableForArticles}
              disabled={saving}
              name="pageTitleTruncateEnableForArticles"
              className="small-spacing2--top"
            />

            <FormsyCheckbox
              label={<p className="body2">Blog</p>}
              defaultChecked={data.pageTitleTruncateEnableForBlogs}
              disabled={saving}
              name="pageTitleTruncateEnableForBlogs"
              className="small-spacing2--top xxlarge-spacing--bottom"
            />

            {/* -------------------------------------------------------------------------------- */}
          </div>
          <div className="seosettings__row">
            <h2 className="small-spacing--bottom">Meta Description</h2>
            <ul className="icon-font-list">
              <HelpLink
                title="How do I set up my meta description settings?"
                url="https://support.pluginuseful.com/hc/en-us/articles/23534846096404-How-do-I-set-up-my-page-title-and-meta-description-settings"
              />
            </ul>
            <FormsyText
              floatingLabelText="Truncate over (characters)"
              defaultValue={data.metaDescriptionTruncateChars}
              disabled={saving}
              name="metaDescriptionTruncateChars"
              validations="isNumeric"
              validationError="Please enter only numbers"
              fullWidth={true}
            />
            <FormsyCheckbox
              label={
                <p className="body2">
                  Override manually entered meta descriptions with templates
                </p>
              }
              defaultChecked={data.metaDescriptionTemplateApplyToAll}
              disabled={saving}
              name="metaDescriptionTemplateApplyToAll"
              className="small-spacing2--top"
            />
          </div>
          <br />
          <h3>Apply To:</h3>
          {/* ----------------------------Meta Description--------------------------------------------------- */}
          <FormsyCheckbox
            label={<p className="body2">Collections</p>}
            defaultChecked={data.metaDescriptionTruncateEnableForCollections}
            disabled={saving}
            name="metaDescriptionTruncateEnableForCollections"
            className="small-spacing2--top"
          />

          <FormsyCheckbox
            label={<p className="body2">Products</p>}
            defaultChecked={data.metaDescriptionTruncateEnableForProducts}
            disabled={saving}
            name="metaDescriptionTruncateEnableForProducts"
            className="small-spacing2--top"
          />

          <FormsyCheckbox
            label={<p className="body2">Pages</p>}
            defaultChecked={data.metaDescriptionTruncateEnableForPages}
            disabled={saving}
            name="metaDescriptionTruncateEnableForPages"
            className="small-spacing2--top"
          />

          <FormsyCheckbox
            label={<p className="body2">Articles</p>}
            defaultChecked={data.metaDescriptionTruncateEnableForArticles}
            disabled={saving}
            name="metaDescriptionTruncateEnableForArticles"
            className="small-spacing2--top"
          />

          <FormsyCheckbox
            label={<p className="body2">Blog</p>}
            defaultChecked={data.metaDescriptionTruncateEnableForBlogs}
            disabled={saving}
            name="metaDescriptionTruncateEnableForBlogs"
            className="small-spacing2--top xxlarge-spacing--bottom"
          />

          {/* -------------------------------------------------------------------------------- */}

          <div className="seosettings__row">
            <h2 className="small-spacing--bottom">Appender</h2>
            <ul className="icon-font-list">
              <HelpLink
                title="How do I set up my appender?"
                url="https://support.pluginuseful.com/hc/en-us/articles/23534798537876-How-do-I-setup-my-page-title-appender"
              />
            </ul>
            <FormsyText
              defaultValue={data.pageTitleAppenderTemplate}
              disabled={saving}
              floatingLabelText="Template"
              fullWidth={true}
              name="pageTitleAppenderTemplate"
              className="spacing__large"
              fullWidth={true}
            />
            <FormsyText
              defaultValue={data.pageTitleAppenderTargetLength}
              disabled={saving}
              floatingLabelText="Target length"
              fullWidth={true}
              name="pageTitleAppenderTargetLength"
              validations="isNumeric"
              validationError="Please enter only numbers"
              className="large-spacing2--bottom"
              fullWidth={true}
            />
            <FormsyCheckbox
              label="Enabled"
              name="pageTitleEnableAppender"
              disabled={saving}
              defaultChecked={data.pageTitleEnableAppender}
              className="large-spacing--bottom"
            />
          </div>
          <div className="seosettings__row">
            <Button
              type="Submit"
              label={saving ? "Saving..." : "Save"}
              buttonType="primary"
              disabled={saving}
            />
          </div>
        </Formsy.Form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/plus/EditSettings.js